import React from 'react';
import { AssetLinks } from '@assets/assets';

export interface ICurrentLoanInfoResponse {
  dealId: null | string;
  rate: number;
  monthlyPaymentAmount: number;
  term: number;
  offerType: string;
}
interface cardProps {
  id?: string | undefined;
  name?: string;
  price?: number;
  interest?: number;
  icon?: string | null;
  selected?: string | undefined;
  showSelectionStyle?: boolean;
  term?: number;
  offer?: ICurrentLoanInfoResponse;
  handleOfferSelection?: (id: string | undefined, offer: ICurrentLoanInfoResponse | undefined) => void;
}
const Card: React.FC<cardProps> = ({
  id,
  icon,
  name,
  price,
  term,
  interest,
  selected,
  offer,
  showSelectionStyle,
  handleOfferSelection,
}) => {
  return (
    <div
      className={`iLendingCDX-card ${selected === id ? 'iLendingCDX-card__selected' : ''}`}
      tabIndex={0}
      aria-label={`${name} for ${price}`}
      onClick={() => handleOfferSelection && handleOfferSelection(id, offer)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleOfferSelection && handleOfferSelection(id, offer);
      }}
    >
      <h1 className="iLendingCDX-card-name">
        {icon && (
          <img
            src={icon}
            alt=""
            className="iLendingCDX-card-icon"
          />
        )}
        {name}
      </h1>
      <p className="iLendingCDX-card-price">
        ${price}/month
        {(selected === id || showSelectionStyle) && (
          <span className="iLendingCDX-card__selected--badge">
            <img
              src={AssetLinks.tickGrey}
              alt=""
            />
            Selected Offer
          </span>
        )}
      </p>
      <p className="iLendingCDX-card-interest">
        {term} Months at {interest}% Rate
      </p>
    </div>
  );
};

export default Card;
